import React, { useEffect, useRef, useState } from "react";
import "./HomePage.scss";
// import MainPageLayout from "../../layouts/Mainpage/MainPageLayout";
import { MDBModal, MDBModalBody } from "mdbreact";
import { lazy } from "react";

import { useMediaQuery } from "react-responsive";
import { fetchQuery } from "relay-runtime";
import environment from "../../environment";

import { setCategoryList } from "../../store/actions/ProductActions";
import { connect } from "react-redux";

import GiftingMutationMutation from "../../mutations/GiftingMutationMutation";
// import CustomButtonPrimary from "../../components/CustomButton/CustomButtonPrimary";

// import {
// 	corporateGiftingGA_II,
// } from "../../utils/GA-Events-II";
import { fbPixel_lead } from "../../utils/FB_pixel_events";
import { image_path } from "../../utils/constants";
// import BestSellers from "./components/BestSellers";

import { ValidateEmailAddress } from "../../utils/utilis";
// import HeroBanner from "./components/HeroBanner";
// import OurExquisiteCollection from "./components/OurExquisiteCollection";
// import GiftYourFavourite from "./components/GiftYourFavourite";
// import CorporateGifting from "./components/CorporateGifting";
// import ChocolateMasterclass from "./components/ChocolateMasterclass";
// import Testimonials from "./components/Testimonials";
// import OurStory from "./components/OurStory";
// import LoadingComponent from "../../components/LoadingComponent/LoadingComponent";
import HomePageQuery from "../../queries/HomePageQuery";
// import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";

const MainPageLayout = lazy(() =>
  import("../../layouts/Mainpage/MainPageLayout.js")
);
const CustomButtonPrimary = lazy(() =>
  import("../../components/CustomButton/CustomButtonPrimary.js")
);
const BestSellers = lazy(() => import("./components/BestSellers.js"));
const HeroBanner = lazy(() => import("./components/HeroBanner.js"));
const OurExquisiteCollection = lazy(() =>
  import("./components/OurExquisiteCollection.js")
);
const GiftYourFavourite = lazy(() =>
  import("./components/GiftYourFavourite.js")
);
const CorporateGifting = lazy(() => import("./components/CorporateGifting.js"));
const ChocolateMasterclass = lazy(() =>
  import("./components/ChocolateMasterclass.js")
);
const Testimonials = lazy(() => import("./components/Testimonials.js"));
const OurStory = lazy(() => import("./components/OurStory.js"));
const LoadingComponent = lazy(() =>
  import("../../components/LoadingComponent/LoadingComponent.js")
);
// import Recognitions from "./components/Recognitions";
const Recognitions = lazy(() => import("./components/Recognitions.js"));

const successGif = image_path + "assets/images/success-gif.gif";
const crossDarkGold =
  image_path + "assets/icons/cross-icon-simple-darkgold.svg";
const goldenbackarrow = image_path + "assets/icons/golden-back-arrow.svg";
const GiftBoxImg = image_path + "assets/images/gift-box-img.png";

let pageLoadingArray = [];
const HomePage = (props) => {
  const { setCategoryListToStore } = props;

  const nextSection = useRef();

  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 });
  const [productVariant_list, setProductVariant_list] = useState([]);
  const [bannerList, setBannerList] = useState([]);
  const [testimonialData, setTestimonialData] = useState([]);
  const [collectionList, setCollectionList] = useState([]);
  const [bestSellerActiveSlide, setBestSellerActiveSlide] = useState(0);
  const [catalogueData, setCatalogueData] = useState({
    name: "",
    file: null,
  });
  const [corporateGiftingstate, setCorporateGiftingstate] = useState(false);
  const [datastore, setdatastore] = useState(false);
  const [count, setCount] = useState(0);

  const [formIsValid, setFormIsValid] = useState(false);
  const [contactDetail, setContactDetail] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    company: "",
  });
  const [touched, setTouched] = useState([]);
  const [error, setError] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    company: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {}, [count]);

  useEffect(() => {
    homePageFetch();
    pageLoadingArray = [];
    // productVariantFetch();
    // categoryFetch();
    // collectionFetch();
    // testimonialDataFetch();
    // catelogueFetch();
  }, []);

  useEffect(() => {
    if (pageLoadingArray.length === 5) {
      setLoading(false);
    }
  }, [pageLoadingArray.length]);

  const handleChange = (e, field) => {
    e.preventDefault();
    if (!touched.includes(field)) {
      setTouched([...touched, field]);
    }
    setContactDetail({
      ...contactDetail,
      [field]: e.target.value.toString(),
    });
  };

  const handleTouch = (field) => {
    if (!touched.includes(field)) {
      setTouched([...touched, field]);
    }
  };

  const validateOnBlur = () => {
    if (
      ValidateEmailAddress(contactDetail.email) &&
      contactDetail.phoneNumber.length === 10 &&
      contactDetail.phoneNumber[0] >= 6 &&
      contactDetail.name !== "" &&
      contactDetail.company !== ""
    ) {
      setError({
        name: false,
        email: false,
        phoneNumber: false,
        company: false,
      });
      setFormIsValid(true);
      setTouched([]);
    } else {
      setFormIsValid(false);
    }

    if (touched.includes("email")) {
      if (!ValidateEmailAddress(contactDetail.email)) {
        let temp = {
          ...error,
          email: true,
        };
        setError(temp);
      } else {
        setError({
          ...error,
          email: false,
        });
        let temp = [...touched];
        temp.splice(touched.indexOf("email"), 1);
        setTouched(temp);
      }
    }

    if (touched.includes("phoneNumber")) {
      if (contactDetail.phoneNumber.length !== 10) {
        setError({
          ...error,
          phoneNumber: true,
        });
      } else {
        setError({
          ...error,
          phoneNumber: false,
        });
        let temp = [...touched];
        temp.splice(touched.indexOf("phoneNumber"), 1);
        setTouched(temp);
      }
    }
    if (touched.includes("name")) {
      if (contactDetail.name === "") {
        setError({
          ...error,
          name: true,
        });
      } else {
        setError({
          ...error,
          name: false,
        });
        let temp = [...touched];
        temp.splice(touched.indexOf("name"), 1);
        setTouched(temp);
      }
    }
    if (touched.includes("company")) {
      if (contactDetail.company === "") {
        setError({
          ...error,
          company: true,
        });
      } else {
        setError({
          ...error,
          company: false,
        });
        let temp = [...touched];
        temp.splice(touched.indexOf("company"), 1);
        setTouched(temp);
      }
    }
  };

  const submitfun = () => {
    if (formIsValid) {
      // debugger
      let data = {
        name: contactDetail.name,
        email: contactDetail.email,
        phoneNumber: contactDetail.phoneNumber,
        company: contactDetail.company,
      };
      GiftingMutationMutation(
        data,
        (response) => {
          if (response.giftingMutation !== null) {
            // cogoToast.success("email id updated Successfully", {position: 'top-center'})
            setdatastore(true);
            // corporateGiftingGA_II()
            fbPixel_lead();
            // setname('')
            // setemail('')
            // setmoblenumber('')
            // setCompanyName('')
          }
        },
        (err) => {
          // cogoToast.error(err, {position: 'top-center'})
        }
      );
    }
    setCount(count + 1);
  };

  function clossall() {
    // setdatastore(false)
    // setCorporateGiftingstate(false)
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  const GoToNextSection = () => {
    window.scrollTo(0, nextSection.current.offsetTop);
  };

  // const checkPageLoadingArray = (value) => {
  // 	debugger
  // 	if(pageLoadingArray.includes(value)){
  // 		let temp = pageLoadingArray.filter(item => item !== value)
  // 		setPageLoadingArray(temp)
  // 		console.log("temp",temp)
  // 	}
  // }

  const homePageFetch = () => {
    let variables = {
      product_IsBestseller: true,
      slug: "corporate-gifting",
      category_Slug_Iexact: "home-page",
    };
    fetchQuery(environment, HomePageQuery, variables)
      .toPromise()
      .then(
        (response) => {
          if (response.productVariants !== null) {
            productVariantFetch(response);
          }
          if (
            response.category !== null 
            // && response.category.edges.length > 0
          ) {
            categoryFetch(response);
          }
          if (response.collections !== null) {
            collectionFetch(response);
          }
          if (
            response.allTestimonials !== null 
            // && response.allTestimonials.edges.length > 0
          ) {
            testimonialDataFetch(response);
          }
          if (response.getCatalogueBySlug !== null) {
            catelogueFetch(response);
          }
          // if (
          //   response.allBanners !== null 
          //   // && response.allBanners.edges.length > 0
          // ) {
          //   setBannerList(response.allBanners.edges);
          //   sendViewPromotionsToGA("Home page banner")
          // }
          // console.log(response)
        },
        (err) => {
          console.log(err);
          setCategoryListToStore([]);
          setProductVariant_list([]);
          setCollectionList([]);
          setTestimonialData([]);
          setCatalogueData({
            name: "",
            file: null,
          });
        }
      );
  };

  const catelogueFetch = (response) => {
    try {
      if (response.getCatalogueBySlug !== null) {
        setCatalogueData({
          file: response.getCatalogueBySlug.file,
          name: response.getCatalogueBySlug.name,
        });
      }
      pageLoadingArray.push("catelogueFetch");
    } catch (err) {
      console.log(error);
      pageLoadingArray.push("catelogueFetch");
    }
  };

  const categoryFetch = (response) => {
    try {
      if (response.category !== null && response.category.edges.length > 0) {
        let data = response.category.edges.map((item) => {
          return {
            id: item.node.id,
            name: item.node.name,
            value: item.node.name,
            checked: false,
            backgroundImage: item.node.backgroundImage,
          };
        });

        setCategoryListToStore(data);
      } else {
        setCategoryListToStore([]);
      }
      pageLoadingArray.push("categoryFetch");
    } catch (err) {
      console.log(err);
      setCategoryListToStore([]);
      pageLoadingArray.push("categoryFetch");
    }

    // checkPageLoadingArray("categoryFetch")
    // fetchQuery(environment, CategoryQuery)
    //   .toPromise()
    //   .then(
    //     (response) => {
    //       if (
    //         response.category !== null &&
    //         response.category.edges.length > 0
    //       ) {
    //         let data = response.category.edges.map((item) => {
    //           return {
    //             id: item.node.id,
    //             name: item.node.name,
    //             value: item.node.name,
    //             checked: false,
    //             backgroundImage: item.node.backgroundImage,
    //           };
    //         });

    //         setCategoryListToStore(data);
    //       } else {
    //         setCategoryListToStore([]);
    //       }
    //       pageLoadingArray.push("categoryFetch");
    //     },
    //     (err) => {
    //       console.log(err);
    //       setCategoryListToStore([]);
    //       pageLoadingArray.push("categoryFetch");
    //     }
    //   );
  };

  const collectionFetch = (response) => {
    // checkPageLoadingArray("collectionFetch")

    try {
      if (response.collections !== null) {
        setCollectionList(response.collections);
      } else {
        setCollectionList([]);
      }
      pageLoadingArray.push("collectionFetch");
    } catch (err) {
      console.log(err);
      setCollectionList([]);
      pageLoadingArray.push("collectionFetch");
    }
  };

  // api
  // ProductQuery has been removed since it has not been used

  const productVariantFetch = (response) => {
    try {
      if (response.productVariants !== null) {
        setProductVariant_list(response.productVariants.edges);
      } else {
        setProductVariant_list([]);
      }
      pageLoadingArray.push("productVariantFetch");
    } catch (err) {
      console.log(err);
      setProductVariant_list([]);
      pageLoadingArray.push("productVariantFetch");
    }
  };

  const testimonialDataFetch = (response) => {
    try {
      if (
        response.allTestimonials !== null &&
        response.allTestimonials.edges.length > 0
      ) {
        setTestimonialData(response.allTestimonials.edges);
      } else {
        setTestimonialData([]);
      }
      pageLoadingArray.push("testimonialDataFetch");
    } catch (err) {
      console.log(err);
      setTestimonialData([]);
      pageLoadingArray.push("testimonialDataFetch");
    }
  };

  // end

  useEffect(() => {
    if (corporateGiftingstate === true) {
      document.body.style.paddingTop = 0 + "px";
    }
  }, [corporateGiftingstate]);

  return (
    <div>
      <div className={loading ? " home-page-loader" : "d-none"}>
        <LoadingComponent />
      </div>

      <div className={"home-page"}>
        {isDesktopOrLaptop === false && corporateGiftingstate === true ? (
          <div className={"main"}>
            <div className={"d-flex back-button"}>
              <img
                src={goldenbackarrow}
                alt={"back button"}
                onClick={() => setCorporateGiftingstate(false)}
                className={"back-btn"}
              />
              Fill the information
            </div>

            <img src={GiftBoxImg} className={"selected-img"} />
            <p
              className={
                "mb-0 euphemia-400-16 fabelle-primary-brown opacity-60 p-3"
              }
            >
              We would love to help you with your corporate gifting needs. In
              order to serve you better, please fill out all the required fields
              and we will get in touch with you. Please note, we deliver in
              Delhi, Mumbai, Bangalore, Chennai, Kolkata, Ahmedabad and
              Hyderabad.
            </p>
            <div className={"details"}>
              <div className={"top-selected-name"}>
                {contactDetail.name.length > 0 && <span>Name</span>}
                <input
                  type={"text"}
                  className={"input name"}
                  placeholder={"Name"}
                  onClick={() => handleTouch("name")}
                  onBlur={validateOnBlur}
                  onChange={(e) => handleChange(e, "name")}
                />
                {error.name && (
                  <p className={"error-message"}>Please enter the Name</p>
                )}
              </div>

              <div className={"top-selected-name"}>
                {contactDetail.email.length > 0 && <span>E-mail</span>}
                <input
                  type={"email"}
                  className={"input email"}
                  placeholder={"Email"}
                  onClick={() => handleTouch("email")}
                  onBlur={validateOnBlur}
                  onChange={(e) => handleChange(e, "email")}
                />
                {error.email && (
                  // valueErrors.field === "email" &&
                  <p className={"error-message"}>Invalid Email Id</p>
                )}
              </div>
              <div className={"top-selected-name"}>
                {contactDetail.phoneNumber.length > 0 && (
                  <span>Phone Number</span>
                )}
                <p className={"country-code"}>+91</p>
                <input
                  min="0"
                  type={"number"}
                  pattern="[0-9]{10}"
                  onKeyPress={(e) =>
                    e.target.value.length === 10 ? e.preventDefault() : null
                  }
                  onChange={(e) => handleChange(e, "phoneNumber")}
                  className={"input number pl-5"}
                  maxLength="10"
                  value={contactDetail.phoneNumber}
                  onClick={() => handleTouch("phoneNumber")}
                  onBlur={validateOnBlur}
                  placeholder={"Phone Number"}
                />

                {error.phoneNumber && (
                  // valueErrors.field === "number" &&
                  <p className={"error-message"}>Invalid Phone Number</p>
                )}
              </div>
              <div className={"top-selected-name "}>
                {contactDetail.company.length > 0 && <span>Company</span>}
                <input
                  type={"text"}
                  className={"input number"}
                  placeholder={"Company Name"}
                  onClick={() => handleTouch("company")}
                  onBlur={validateOnBlur}
                  onChange={(e) => handleChange(e, "company")}
                />
                {error.company && (
                  // valueErrors.field === "Company" &&
                  <p className={"error-message"}>Please enter Company</p>
                )}
              </div>
            </div>
            <div
              className={
                " settle-at-bottom " +
                (isDesktopOrLaptop
                  ? "top-btn-bg"
                  : "mobile-bottom-button-section")
              }
            >
              <CustomButtonPrimary
                name={"Continue"}
                disabled={!formIsValid}
                className={
                  isDesktopOrLaptop
                    ? "euphemia-700-20"
                    : "euphemia-700-20 w-100"
                }
                theme={"light"}
                clickHandler={() => submitfun()}
              />
            </div>
            <div className={"success-modal"}>
              {datastore && (
                <MDBModal fullHeight={false} isOpen={datastore}>
                  <MDBModalBody>
                    <div className={"modal-component-header text-right"}>
                      <img
                        src={crossDarkGold}
                        onClick={() => clossall()}
                        className={"close-img"}
                      />
                      <div className={"gif text-center"}>
                        <img
                          src={successGif}
                          alt={"done"}
                          className={"mx-auto"}
                        />
                      </div>
                    </div>
                    <div className={"modal-component-content"}>
                      <p className={"title"}>Successful!</p>
                      <p className={"text "}>
                        Your details have been received and you would be
                        contacted shortly
                      </p>
                    </div>
                  </MDBModalBody>
                </MDBModal>
              )}
            </div>
          </div>
        ) : (
          <div className="home-layout-swift">
            <MainPageLayout activePage={"home"}>
              <div style={{ minHeight: isDesktopOrLaptop ? "70vh" : "28vh" }}>
                <HeroBanner
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  GoToNextSection={GoToNextSection}
                  // bannerList={bannerList}
                />
              </div>
              <div style={{ minHeight: "40vh" }}>
                <div ref={nextSection}>
                  {collectionList.length > 0 && (
                    <OurExquisiteCollection data={collectionList} />
                  )}
                </div>

                {productVariant_list.length > 0 && (
                  <BestSellers
                    productVariant_list={productVariant_list}
                    bestSellerActiveSlide={bestSellerActiveSlide}
                    setBestSellerActiveSlide={setBestSellerActiveSlide}
                  />
                )}
                <OurStory />
              </div>
              <div style={{ minHeight: "40vh" }}>
                <GiftYourFavourite />
              </div>
              <div style={{ minHeight: "40vh" }}>
                <CorporateGifting
                  catalogueData={catalogueData}
                  setCorporateGiftingstate={setCorporateGiftingstate}
                  corporateGiftingstate={corporateGiftingstate}
                />
              </div>
              <ChocolateMasterclass isDesktopOrLaptop={isDesktopOrLaptop} />
              {/*<BakeWithFabelle/>*/}
              <Recognitions isDesktopOrLaptop={isDesktopOrLaptop} />
              {testimonialData.length > 0 && (
                <Testimonials data={testimonialData} />
              )}
            </MainPageLayout>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categoryListFromStore: state.ProductReducer.categoryList,
});
const mapDispatchToProps = (dispatch) => ({
  setCategoryListToStore: (data) => dispatch(setCategoryList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
